// src/auth/roles.js
export const ROLES = {
  ADMIN: 'ADMIN',
  CLINIC: 'CLINIC',
  USER: 'USER',
  PARENT: 'PARENT',
};


export function hasAnyRole(role, allowed = []) {
  return Array.isArray(allowed) && allowed.includes(role);
}